import CreateArticleContainer from "@containers/dashboard/articles/create";
import { useAuth } from "@contexts/auth";
import DashboardLayout from "@layouts/dashboard";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CreateArticle = () => {
    const { profile } = useAuth();

    const Navigate = useNavigate();

    useEffect(() => {
        if (profile.role === "admin") {
            Navigate("/dashboard/articles");
        }
    }, [profile.role]);

    return (
        <DashboardLayout title="مقاله جدید">
            <CreateArticleContainer />
        </DashboardLayout>
    );
};

export default CreateArticle;
